import React, { useState } from "react";
import { connect } from "react-redux";
import { getVariationsByBatch } from "../../../actions/variableProductAction";
import { Row, Col, AutoComplete, Button, Spin, message } from "antd";

const BatchwiseBarcode = ({
  getVariationsByBatch,
  setloading,
  barcodelist,
  setreload,
  reload,
}) => {
  const [batchNo, setBatchNo] = useState("");
  const [searching, setSearching] = useState(false);

  const handleSearch = async () => {
    if (!batchNo.trim()) {
      message.warning("Please enter a batch number");
      return;
    }

    setSearching(true);
    setloading(true);
    barcodelist.current = [];

    try {
      const variations = await getVariationsByBatch(batchNo.trim());
      
      if (variations && variations.length > 0) {
        // Add variations to barcode list
        variations.forEach((variation) => {
          barcodelist.current.push({
            variation: variation,
            Quantity: 1, // Default quantity
          });
        });
        
        message.success(`Found ${variations.length} variation(s) with batch number: ${batchNo}`);
        setreload(!reload);
      } else {
        message.info("No variations found with this batch number");
      }
    } catch (error) {
      console.error("Error fetching variations:", error);
      message.error("Failed to fetch variations. Please try again.");
    } finally {
      setSearching(false);
      setloading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClear = () => {
    setBatchNo("");
    barcodelist.current = [];
    setreload(!reload);
  };

  return (
    <Row gutter={16}>
      <Col span={12}>
        <h3>Search by Batch Number</h3>
        <AutoComplete
          placeholder="Enter batch number (e.g., BATCH001)"
          value={batchNo}
          onChange={(value) => setBatchNo(value)}
          onKeyPress={handleKeyPress}
          style={{ width: "100%", marginBottom: "10px" }}
          disabled={searching}
        />
        <Button
          type="primary"
          onClick={handleSearch}
          loading={searching}
          disabled={!batchNo.trim()}
          style={{ marginRight: "8px" }}
        >
          Search
        </Button>
        <Button onClick={handleClear} disabled={searching}>
          Clear
        </Button>
      </Col>
      {searching && (
        <Col span={12} style={{ display: "flex", alignItems: "center" }}>
          <Spin tip="Searching variations by batch number..." />
        </Col>
      )}
    </Row>
  );
};

export default connect(null, { getVariationsByBatch })(BatchwiseBarcode);